import { Component, OnInit, OnDestroy } from '@angular/core';
import { Schedule } from 'src/app/models/schedule-models/schedule.model';
import { Subscription } from 'rxjs';
import { FormsTurnsService } from 'src/app/services/turns-services/forms-turns-service/forms-turns.service';
import { ActivatedRoute } from '@angular/router';
import { SnackBarService } from 'src/app/components/shared-components/snack-bar/snack-bar.service';
import { HeaderBreadcrumbService } from '../../header-components/header-breadcrumb/header-breadcrumb.service';
import { Breadcrumb } from 'src/app/models/breadcrumb-models/breadcrumb-model/breadcrumb.model';
import { BRoute } from 'src/app/models/breadcrumb-models/breadcrumb-route-model/breadcrumb-route.model';

@Component({
  selector: 'app-turns-form-turn-schedule-dashboard',
  templateUrl: './turns-form-turn-schedule-dashboard.component.html',
  styleUrls: ['./turns-form-turn-schedule-dashboard.component.scss']
})
export class TurnsFormTurnScheduleDashboardComponent implements OnInit, OnDestroy {

  formid;
  schedule: Schedule;
  getFormScheduleSubscription: Subscription;

  constructor(private formsTurnsService: FormsTurnsService,
              private activatedRoute: ActivatedRoute,
              private snackbarService: SnackBarService,
              private headerBreadcrumbService: HeaderBreadcrumbService) { }

  ngOnInit() {
    this.formid = this.activatedRoute.snapshot.params['formid'];
    this.setBreadcrumb();
    this.getSchedule();
  }

  public getSchedule() {
    const internalId = this.activatedRoute.snapshot.params['scheduleid'];
    const relatedEntityInternalId = this.activatedRoute.snapshot.params['formid'];
    this.getFormScheduleSubscription = this.formsTurnsService.getFormAvailabilityScheduleInfo(internalId, relatedEntityInternalId).subscribe(
      (res) => {
        const calendar = res['data']['formCalendar'] || res['data']['availabilityCalendar'] || res['data']['calendar'];
        if (calendar) {
          const schedule = new Schedule();
          Object.assign(schedule, calendar);
          this.schedule = schedule;
        }
      },
      (error) => {
        this.snackbarService.open(error['error']['message'], 'error');
      }
    );
  }

  private setBreadcrumb() {
    this.headerBreadcrumbService.setRoutes(new Breadcrumb('fas fa-calendar-day', 'turns-page.turn schedule detail', '/turns/form/' + this.formid, [new BRoute('turns-page.turns', '/turns'), new BRoute('turns-page.forms', '/turns/forms'), new BRoute('turns-page.form detail', '/turns/form/' + this.formid), new BRoute('turns-page.turn schedule detail')]));
  }

  ngOnDestroy() {
    if (this.getFormScheduleSubscription) { this.getFormScheduleSubscription.unsubscribe(); }
  }
}
